<ng-container *ngIf="profileField$ | async as profileField">
    <dt [id]="profileField.FieldDefinition.FlatKey" class="sh-description-list__term">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="labelIcons"></sh-field-label>
    </dt>
    <ng-container *ngIf="childDefinition$ | async as childDefinition">
        <ng-container *ngIf="listValues">
            <dd class="sh-description-list__details" *ngIf="listValues.length > 0; else emptyData">
                <span *ngFor="let value of listValues; let index = index">
                    <med-complex-value-tag
                        [complexValue]="value"
                        [complexFieldDefinition]="childDefinition"
                        [label]="getWebserviceValue(value)"
                    ></med-complex-value-tag>
                    <ng-container *ngIf="index < listValues.length - 1">, </ng-container>
                </span>
            </dd>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #emptyData>
    <dd class="sh-description-list__details">-</dd>
</ng-template>
